import React from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';
import { setRowSize } from 'utils';
class CPRemarksContainer extends React.Component {
  render() {
    return (
      <AccordionWrapper
        {...this.props}
        collapsed={false}
        accordionTitle="chemical.product.details.page.remarks.container.title"
        tooltip="chemical.product.details.page.remarks.container.title.tooltip"
        render={this.getContainerContent}
        className="containerReducedWhiteSpace"
      />
    );
  }

  getContainerContent = () => {
    const { values, disabled, chemicalProductDisabled } = this.props;
    const inputText = values.chemicalProduct.remarks || '';
    const rows = setRowSize(inputText, 2, 90);

    return (
      <Grid stackable columns={1} verticalAlign="bottom">
        <GridColumnInputWrapper
          {...this.props}
          disabled={disabled || chemicalProductDisabled}
          value={inputText}
          name="chemicalProduct.remarks"
          render={props => <InputWrapper {...props} type="textarea" rows={rows} />}
        />
      </Grid>
    );
  };
}

export default CPRemarksContainer;
